import React, {Component} from "react";
import {connect} from "react-redux";
import SVGIcon from "./../svg/SVGIcon";

import {startOverMapAction, setMapZoomAction} from "./../../actions/DataAction";

import "./MapButton.css";

class MapButton extends Component {

  constructor(props) {
    super(props);
    this.getIcon = this.getIcon.bind(this);
    this.onClickMapControl = this.onClickMapControl.bind(this);
  }

  onClickMapControl(){
    const {action, setMapZoom, startOverMap} = this.props;
    switch (action) {
      case 'startOver':
        startOverMap();
        break;
      case 'zoomIn':
        setMapZoom(true);
        break;
      case 'zoomOut':
        setMapZoom(false);
        break;
      default:
        break;
    }
  }

  getIcon(){
    const {action} = this.props;
    let iconName, iconParams;
    switch (action) {
      case 'startOver':
        iconName = 'startover';
        iconParams = {
          strokeWidth: 1.68,
          stroke: "#2048DD"
        }
        break;
      case 'zoomIn':
        iconName = 'zoom-in';
        iconParams = {
          strokeWidth: 1.68,
          stroke: "#2048DD"
        }
        break;
      case 'zoomOut':
        iconName = 'zoom-out';
        iconParams = {
          strokeWidth: 1.68,
          stroke: "#2048DD"
        }
        break;
      default:
        break;
    }
    return <SVGIcon name={iconName} {...iconParams} />
  }

  render() {
    const icon = this.getIcon();
    return (
      <div className="fow-map-button" onClick={this.onClickMapControl}>{icon}</div>
    );
  }
}

const mapStateToProps = state => {
  return {

  };
};
const mapDispatchToProps = dispatch => ({
  startOverMap: () => dispatch(startOverMapAction()),
  setMapZoom: data => dispatch(setMapZoomAction(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MapButton);
